angular.module('sodDocumentLibrary', ['ngLodash', 'dialog-manager', 'ActionManager', 'ResourceGenerator']);